<template>
  <p class="modal-container-desc-ui">
    <slot />
  </p>
</template>
